export default __webpack_public_path__ + "static/media/infoERP_Agency_Setup.8b3a692c.zip";